import { includes } from "lodash";
import { Metric } from "@linkfluence/models/metric";
import { Platform } from "@linkfluence/models/platform";
import { SortInfluencer } from "../search";
import {
  Influencer,
  InfluencerAccountMetric,
  InfluencerPlatforms,
  SearchableInfluencer,
} from ".";

export function getPlatformFromInfluencer(influencer: Influencer): Platform {
  return influencer.platform;
}

export function getMetricFromSort(sort: SortInfluencer): Metric {
  if (includes([Metric.Doc, Metric.Reach, Metric.Engagement], sort)) {
    return sort as Metric;
  } else {
    return Metric.Doc;
  }
}

export function getCountFromSort(
  influencer: SearchableInfluencer,
  sort: SortInfluencer
) {
  return influencer.counts[getMetricFromSort(sort)];
}

export class InfluencerLens<I extends Influencer> {
  influencer: I;
  constructor(influencer: I) {
    this.influencer = influencer;
  }
  public getPlatform(): Platform {
    return this.influencer.platform;
  }
  public getId(): string {
    return this.influencer.idStr;
  }
  public getUID(): string {
    return this.getId() + "_" + this.influencer.platform;
  }
  public isVerified(): boolean {
    return false;
  }
  public getPermalink(): string {
    return null;
  }
  public getName(): string {
    return this.influencer.name !== null
      ? this.influencer.name
      : this.getScreenName();
  }
  public getScreenName(): string {
    return null;
  }
  public getAvatar(): string {
    return null;
  }
  public getDescription(): string {
    return null;
  }
  public getOccupation(): string {
    return null;
  }
  public getCountry(): string {
    return null;
  }
  public getAccountMetrics(): InfluencerAccountMetric[] {
    return [];
  }
  public getQuery() {
    const id = this.getId();
    return `user.${this.influencer.platform as string}.id:${id}`;
  }

  public isPlatform<K extends keyof InfluencerPlatforms>(platform: K) {
    return this.influencer.platform === platform;
  }
}
